export default "__VITE_ASSET__HuM4eG9C__"